var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('page-header',{attrs:{"actions":_vm.actions,"header":_vm.$t('coupons.title')}}),_c('div',{staticClass:"content"},[_c('admin-table',_vm._b({scopedSlots:_vm._u([{key:"multiuse",fn:function(ref){
var item = ref.item;
return [_c('i',{class:{
            'icon-check': item.multiuse,
            'icon-cross3': !item.multiuse,
          }})]}}])},'admin-table',_vm.tableProps,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }